import { gql } from 'urql';

const BillManagerQualificationQuery = gql`
  query BillManagerQualification {
    billManagerQualification {
      qualified
    }
  }
`;

export default BillManagerQualificationQuery;
